import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SearchTemplate } from "~/features/search/SearchTemplate";

const searchSchema = z.object({
  /**
   * 検索画面の呼び出し元。messages / instantCall / favorites のときは検索実行で結果画面へ行かず、
   * 呼び出し元の一覧（メッセージ一覧・今すぐビデオ通話できる女の子・お気に入りの近況）を絞り込む
   */
  from: z.enum(["messages", "instantCall", "favorites"]).optional(),
});

export const Route = createFileRoute("/_authenticated/search/")({
  validateSearch: searchSchema,
  component: SearchTemplate,
});
